import { FC, Fragment, JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { AddRounded as AddRoundedIcon } from '@mui/icons-material';
//components
import UsersTable from 'components/main/Users/UsersTable';
// constant, styles, reducer, graphql
import { flexCenterBetween } from 'styles/commonComponentStyle';
import { USERS_TEXT, ADD_NEW_TEXT, ADD_USER_ROUTE } from 'constants/index';

const Users: FC = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <Box sx={flexCenterBetween}>
        <Typography variant="h5">{USERS_TEXT}</Typography>
        <Button variant="contained" color="primary" onClick={() => navigate(ADD_USER_ROUTE)}>
          <AddRoundedIcon />
          {ADD_NEW_TEXT}
        </Button>
      </Box>
      <UsersTable />
    </Fragment>
  );
};

export default Users;
